import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Typography,
  Stack,
} from "@mui/material";
import FillerImage from "../../../assets/images/Filler-Harmony-8-1-22.gif";

export default function ProductSeries(props) {
  const tableData = props.data;

  return (
    <>
      <Typography variant="h2" sx={{ marginTop: "2rem" }}>
        Standard Product Series
      </Typography>
      <Stack direction="row" spacing={15} alignItems="center">
        <Table size="small" sx={{ maxWidth: "54.6rem" }}>
          <TableHead>
            <TableRow>
              {tableData &&
                Object.values(tableData.header).map((header, i) => (
                  <TableCell key={i++}>
                    <Typography>{header}</Typography>
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData &&
              tableData.lines.map((header, i) => (
                <TableRow key={i++}>
                  {Object.values(header).map((seriesData) => (
                    <TableCell key={i++}>
                      <Typography>{seriesData}</Typography>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
        <img src={FillerImage} alt="filler for small table" />
      </Stack>
    </>
  );
}
